import React from "react";
import { BoxIcon } from "lucide-react";
interface EmptyStateProps {
  icon: BoxIcon;
  title: string;
  description: string;
  action?: React.ReactNode;
  headingLevel?: 'h1' | 'h2';
}
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  headingLevel = 'h2'
}: EmptyStateProps) {
  const Heading = headingLevel;
  return <div className="flex flex-col items-center px-6 py-16 text-center md:py-24" data-id="element-132" data-mp="y4xrs6qngdtx">
      <div className="flex h-14 w-14 items-center justify-center rounded-full border border-graphite text-mist" data-id="element-133" data-mp="1c4p9oikaeed7">
        <Icon aria-hidden="true" className="h-6 w-6" data-id="element-134" data-mp="176nhn84vv4pl" />
      </div>
      <Heading className="mt-6 font-display text-xl font-bold text-white md:text-2xl" data-id="element-135" data-mp="1lw38sp8btc5t">{title}</Heading>
      <p className="mt-3 max-w-md text-sm leading-relaxed text-mist md:text-base" data-id="element-136" data-mp="1gxrv23ewuhib">{description}</p>
      {action && <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-137" data-mp="1uxb4r0nde0wq">{action}</div>}
    </div>;
}